// config/api.js - API base URL configuration
export const API_BASE = process.env.REACT_APP_API_URL || '/api';
